<template>
  <div class="gm-admin-tab">
    <server-table
      class="text-center groovemail-admin-spam-alert-table"
      ref="serverTable"
      url="spam-alerts"
      tableRef="spamAlertTable"
      :slotData="alertListingTableSlotData"
      :tableColumns="spam_alertsTableColumns"
      :tableOptions="spam_alertTableOptions"
      @loaded="hideLoader()"
      @loading="showLoader()"
    />
    <user-access-model ref="userAccess" @refreshTable="refreshTable"></user-access-model>

    <!-- Confirmation remove alert modal -->
    <confirm-modal
      :ref="`confirmation-remove-alert`"
      :name="`confirmation-remove-alert`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_spam_alert_are_you_sure')"
      @confirm="removeAlert"
      @close="closeConfirmRemoveAlert"
    />
  </div>
</template>

<script>
import axios from 'axios';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import impersonate from './impersonateUser';
import UserAccessModel from '@/components/UserAccessModel.vue';
import userStatusSvgImages from '../Form/UserStatusSvg.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';
import { showRequestErrorAlert } from '@/components/showDialog.js';

import themeConfig from '@/theme/themeConfig';

let self;

export default {
  middleware: 'auth',
  mixins: [impersonate, demoModeValuesMixin],
  metaInfo() {
    return {
      title: this.$t(
        'frontend_groovemail_components_pricepoint_sidebar_broadcasts'
      ),
    };
  },

  data() {
    return {
      appName: '',
      tableKey: 1,
      last_page: '',
      model: {
        from: '',
        to: '',
        subject: '',
        content: '',
        accessBlockReason:'',
        accessBlockByUser:''
      },
      formSubmitted: false,
      userId: '',
      type:'',
      userStatusSvgImages: userStatusSvgImages,
      spam_alertsTableColumns: [
        'user.email',
        'status',
        'total_alerts',
        'created_at',
        'name',
        'total_recipients',
        'total_spam',
        'total_bounced',
        'actions',
      ],
      spam_alertTableOptions: {
        perPage: 25,
        debounce: 1000,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        filterable: true,
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: [
          'total_alerts',
          'total_recipients',
          'total_spam',
          'total_bounced',
        ],
        headings: {
          'user.email': () => this.$t('frontend_groovemail_spam_alert_username'),
          status: () => this.$t('frontend_groovemail_admin_forms_owner_status'),
          total_alerts: () => this.$t('frontend_groovemail_spam_alert_history'),
          created_at: () => this.$t('frontend_groovemail_spam_alert_date'),
          email: () => this.$t('frontend_groovemail_spam_alert_email'),
          total_recipients: () =>
            this.$t('frontend_groovemail_spam_alert_recipients'),
          total_spam: () => this.$t('frontend_groovemail_spam_alert_spam'),
          total_bounced: () =>
            this.$t('frontend_groovemail_spam_alert_bounces'),
          actions: () => this.$t('frontend_groovemail_spam_alert_action'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              user: {
                ...obj.user,
                email: self.basicEmailText
              },
              name: self.basicText
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data.data,
            count: data.total,
          };
        },
      },
      confirmId: '',
    };
  },
  validations: {
    model: {
      accessBlockReason: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(500),
      },
      accessBlockByUser: {
        required,
      },
    },
  },
  components: {
    ServerTable,
    UserAccessModel
  },

  async created() {
    self=this;
  },

  mounted() {
    this.appName = this.supBrandName;
  },

  watch: {
    // Used to refresh black list table when demo mode changes
    demoMode() {
      this.refreshTable();
    },
  },

  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    showcampaign(Id) {
      this.$router.push({
        name: 'CampaignDetail',
        params: { id: Id },
        query: { from: 'broadcast-listing' },
      });
    },
    openEditMailsequence(seqId) {
      this.$router.push({
        name: 'Sequencestep',
        params: { id: seqId },
      });
    },
    showalerthistory(userId) {
      this.$router.push({
        name: 'UserAlerts',
        params: { id: userId },
      });
    },

    // open confirmation action modal
    async openConfirmRemoveAlert(id) {
      this.confirmTarget = id;

      // open the modal
      this.$refs[`confirmation-remove-alert`].open();
    },

    // close confirmation action modal
    closeConfirmRemoveAlert() {
      // reset the confirm id
      this.confirmId = '';
    },

    async removeAlert() {
      try {
        this.showLoader();

        // remove the alert
        await axios.delete(`/spam-alerts/${this.confirmId}`);
        
        // after removing the alert, refresh the table
        const alertData = await axios.get(
          `/spam-alerts?query=${this.$refs.spamAlertTable.filteredQuery}&limit=${this.spam_alertTableOptions.perPage}&page=${this.$refs.spamAlertTable.Page}&ascending=1&byColumn=0`
        );
        this.$refs.spamAlertTable.data = alertData.data.data;
        this.$refs.spamAlertTable.count = alertData.data.total;
        this.hideLoader();
      } catch (error) {
        this.hideLoader();

        // show error alert
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Used to refresh the table
    refreshTable() {
      this.$refs.serverTable.$refs.spamAlertTable.refresh();
    },
  },

  computed: {
    // Used to return brandData value from store.
    supBrandName() {
      return this.$store.getters.supBrand.title;
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },
    modalTitle() {
      return this.type=='smtp'
        ? this.$t(
            'frontend_groovemail_admin_user_smtp_modal_label'
          )
        : this.$t(
            'frontend_groovemail_admin_user_access_modal_label'
          );
    },
    alertListingTableSlotData() {
      return [
        {
          slotName: 'username',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.email ? props.row.email : 0;
          },
        },
        {
          slotName: 'status',
          slotType: 'tooltip',
          showText: false,
          textValue: (props) => {
            return '';
          },
          classes: () => {
            return '';
          },
          conditions: () => {
            return true;
          },
          content: (props) => {
            if((props.row.user.status==1 || props.row.user.groovemail_smtp == 0) && (props.row.user.block_reason !='' || props.row.user.blocked_by !='')){
              let tooltipContent = `<div class='flex'>`;            
              tooltipContent += `<p class='pl-1 break-words'>${props.row.user.block_reason}</p></div>`;
              tooltipContent += `<div class='flex'><p class='font-semibold break-words'>${this.$t(
              'frontend_groovemail_admin_forms_blocked_by'
            )}:</p><p class='pl-1 break-words'>${props.row.user.blocked_by}</p></div>`;
            return tooltipContent;
            }
          },
          html: (props) =>{
            if(props.row.user.status==1){
              return `<p class='user-status-cross-icons'>${this.userStatusSvgImages[0].crossicon}<span>Disabled ${this.appName}</span></p>`;
            }else if(props.row.user.groovemail_smtp == 0){
              return `<p class='user-status-ban-icons'>${this.userStatusSvgImages[0].banicon}<span>Disabled Smtp</span></p>`;   
            }else{
              return `<p class='user-status-check-icons'>${this.userStatusSvgImages[0].checkicon}<span>All Good</span></p>`;
            }
          }
        },
        {
          slotName: 'total_alerts',
          slotType: 'clickable',
          classes: 'hover:underline',
          defaultValue: 0,
          callback: (props) => this.showalerthistory(props.row.user_id),
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'name',
          slotType: 'clickable',
          callback: (props) => {
            if (props.row.source == 1) this.showcampaign(props.row.source_id);
            else if (props.row.source == 3)
              this.openEditMailsequence(props.row.source_id);
          },
          classes: () => {
            return 'hover:underline';
          },
          defaultValue: this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'total_recipients',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.total_recipients ? props.row.total_recipients : 0;
          },
        },
        {
          slotName: 'total_spam',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return `${props.row.total_spam ? props.row.total_spam : 0} (${
              props.row.total_spam && props.row.total_recipients
                ? (props.row.total_spam * 100) / props.row.total_recipients
                : 0
            }%)`;
          },
        },
        {
          slotName: 'total_bounced',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return `${props.row.total_bounced ? props.row.total_bounced : 0} (${
              props.row.total_bounced && props.row.total_recipients
                ? (props.row.total_bounced * 100) / props.row.total_recipients
                : 0
            }%)`;
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_groovemail_spam_alert_remove'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openConfirmRemoveAlert(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_groovemail_login_to_owner_account'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.impersonateLogin(
                props.row.user.email,
                this.appName.toLowerCase()
              ),
            },
            {
              id: 2,
              name: () => this.$t('frontend_groovemail_disable_smtp'),
              conditions: (props) => {
                if(props.user.groovemail_smtp == 0 || props.user.status == 1){
                  return false;
                }
                return true;
              },
              callback: (props) => this.$refs.userAccess.editUserAccess(props.row.user_id,'smtp'),
            },
            {
              id: 3,
              name: () => this.$t('frontend_groovemail_disable_access'),
              conditions: (props) => {
                if(props.user.status == 1){
                  return false;
                }
                return true;
              },
              callback: (props) => this.$refs.userAccess.editUserAccess(props.row.user_id,'access'),
            },
            {
              id: 4,
              name: () => this.$t('frontend_groovemail_admin_enable_access'),
              conditions: (props) => {
                if(props.user.status == 1){
                  return true;
                }
                return false;
              },
              callback: (props) => this.$refs.userAccess.enableUserAccess(props.row.user_id,'access'),
            },
            {
              id: 5,
              name: () => this.$t('frontend_groovemail_admin_enable_smtp'),
              conditions: (props) => {
                if(props.user.status == 0 && props.user.groovemail_smtp == 0){
                  return true;
                }
                return false;
              },
              callback: (props) => this.$refs.userAccess.enableUserAccess(props.row.user_id,'smtp'),
            }
          ],
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-admin-spam-alert-table #gd-server-table-view {
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(6) {
      width: 8%;
    }
    td:nth-child(1) {
      width: 20%;
      word-break: break-word;
    }
  }
}
</style>
